import { JackpotWins } from 'api/common';

const checkForTestWord = /\btest\b/i;

export const filterJackpotWinsListFromTest = (jackpotWins: JackpotWins[]) =>
  jackpotWins.filter(({ jackpotName }) => !checkForTestWord.test(jackpotName));
